var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHnLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 88,
    height: 88,
    rx: 18,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2017 61V31.9091H25.233V43.5852H36.696V31.9091H43.7131V61H36.696V49.3097H25.233V61H18.2017ZM72.8821 31.9091V61H66.9162L55.3395 44.2102H55.1548V61H48.1236V31.9091H54.1747L65.6236 48.6705H65.8651V31.9091H72.8821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnLang);
export default __webpack_public_path__ + "static/media/hn-lang.40f49353d0f1b515ae79836043610937.svg";
export { ForwardRef as ReactComponent };